import { MemoryTab } from '@apps/web/components/memory/memory_tab';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@apps/web/components/ui/dialog';
import { type NoteOutcomeEntity } from '@apps/web/lib/agent_note_outcome_copy';

/**
 * What Phoebe knows about one person, opened in place.
 *
 * Renders the profile's own memory surface rather than a second read-only
 * copy of it: a reader who opens a memory from chat and one who opens it
 * from the profile are looking at the same record, and a private copy here
 * drifts from the real one the first time either changes.
 */
export function MemoryRecordModal({
    organizationId,
    entity,
    onClose,
}: {
    readonly organizationId: string;
    readonly entity: NoteOutcomeEntity;
    readonly onClose: () => void;
}) {
    return (
        <Dialog
            open={true}
            onOpenChange={(next) => {
                if (!next) {
                    onClose();
                }
            }}
        >
            <DialogContent className="max-h-[80vh] overflow-y-auto sm:max-w-2xl">
                <DialogHeader>
                    <DialogTitle>{entity.name}</DialogTitle>
                    <DialogDescription>
                        What Phoebe knows about them.
                    </DialogDescription>
                </DialogHeader>
                <MemoryTab
                    organizationId={organizationId}
                    entityId={entity.id}
                    entityType={entity.type}
                />
            </DialogContent>
        </Dialog>
    );
}
